module.exports = __webpack_public_path__ + "img/b.6c02ed1b.svg";